import { render, staticRenderFns } from "./thread-tag.vue?vue&type=template&id=af64c66e&"
import script from "./thread-tag.vue?vue&type=script&lang=js&"
export * from "./thread-tag.vue?vue&type=script&lang=js&"
import style0 from "./thread-tag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports